import { gql } from '@apollo/client';
export const queryMeta = {
    project: {
        addMemberMutation: 'addCollaboratorsToProject',
        removeMemberMutation: 'removeCollaboratorsFromProject',
        addMemberMutationResponseType: 'AddCollaboratorsToProject',
        removeMemberMutationResponseType: 'RemoveCollaboratorsFromProject',
        addGroupMutation: 'addTeamsToProject',
        addGroupsMutationTypename: 'AddTeamsToProject',
        removeGroupsMutation: 'removeTeamsFromProject',
        removeGroupsTypename: 'RemoveTeamsFromProject',
        itemIdField: 'projectPk',
        itemNodeType: 'ProjectNode',
        idField: 'pk',
        idType: 'Int',
        pkField: 'projectPk',
        optimisticSucceededResponse: (member) => (Object.assign(Object.assign({}, member), { __typename: 'CollaboratorNode' })),
        memberEdgeAnnotation: 'isProjectCollaborator',
        memberEdgeType: 'CollaboratorEdge',
        memberNodeType: 'CollaboratorNode',
        nodeIndexKey: 'email',
        getAddedCollaboratorsFromResponse(attemptedMembers, succeeded) {
            return succeeded;
        },
        teamEdgeConnection: 'isAddedToProject',
        updatePasswordMutation: 'passwordProtectProject',
        updatePasswordMutationResponseType: 'PasswordProtectProject',
    },
    folder: {
        addMemberMutation: 'addUsersToFolder',
        removeMemberMutation: 'removeUsersFromFolder',
        addMemberMutationResponseType: 'AddUsersToFolder',
        removeMemberMutationResponseType: 'RemoveUsersFromFolder',
        addGroupMutation: 'addTeamsToFolder',
        addGroupsMutationTypename: 'AddTeamsToFolder',
        removeGroupsMutation: 'removeTeamsFromFolder',
        removeGroupsTypename: 'RemoveTeamsFromFolder',
        itemIdField: 'folderId',
        itemNodeType: 'FolderNode',
        idField: 'id',
        idType: 'String',
        pkField: 'folderPk',
        optimisticSucceededResponse: ({ email }) => email,
        memberEdgeAnnotation: 'isFolderMember',
        memberEdgeType: 'MemberEdge',
        memberNodeType: 'MemberNode',
        nodeIndexKey: 'pk',
        getAddedCollaboratorsFromResponse(attemptedMembers, succeeded) {
            // this is really annoying the mutation should return enough information
            // for us to add the user without fetching it separately!
            return attemptedMembers.filter(({ email }) => succeeded.indexOf(email !== -1));
        },
        teamEdgeConnection: 'isAddedToFolder',
        updatePasswordMutation: 'passwordProtectFolder',
        updatePasswordMutationResponseType: 'PasswordProtectFolder',
    },
    group: {
        addMemberMutation: 'addMembersToTeam',
    },
};
export function getSharingData(itemName) {
    if (itemName === 'project') {
        return gql `
      query GET_SHARING_DATA($itemPk: Int, $itemId: String) {
        project(pk: $itemPk, shareId: $itemId) {
          pk
          name
          companyPk
          passwordProtected
          owner {
            pk
          }
          visibility
          prototypeUrl
          embed(homescreenPrompt: false, frameless: false) {
            iframe
          }
        }
      }
    `;
    }
    if (itemName === 'folder') {
        return gql `
      query GET_SHARING_DATA($itemId: String!) {
        folder(id: $itemId) {
          pk
          name
          companyPk
          passwordProtected
          owner {
            pk
          }
          visibility
        }
      }
    `;
    }
}
export function getCompanyMembers(itemName) {
    const { memberEdgeAnnotation, pkField } = queryMeta[itemName];
    return gql `
    query GET_COMPANY_USERS(
      $username: String
      $cursor: String
      $itemPk: Int!
    ) {
      user {
        pk
        company {
          pk
          members(username: $username, first: 6, after: $cursor)
            @connection(key: "members") {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              ${memberEdgeAnnotation}(${pkField}: $itemPk)
              node {
                pk
                avatarUrl
                email
                username
                role
              }
            }
          }
        }
      }
    }
  `;
}
export function getCollaborators(itemName) {
    const { idType, idField } = queryMeta[itemName];
    return gql `
    query GET_COLLABORATORS($itemId: ${idType}!, $cursor: String) {
      ${itemName}(${idField}: $itemId) {
        pk
        owner {
          pk
        }
        collaborators(first: 6, after: $cursor)
          @connection(key: "collaborators") {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              addedViaTeam
              pk
              avatarUrl
              email
              username
              role
            }
          }
        }
      }
    }
  `;
}
export function getAddCollaborators(itemName) {
    if (itemName === 'project') {
        return gql `
      mutation ADD_COLLABORATORS($itemPk: Int!, $emails: [String]!) {
        addCollaboratorsToProject(
          input: { projectPk: $itemPk, emails: $emails }
        ) {
          succeeded {
            email
            pk
            username
            avatarUrl
            role
          }
          failed {
            code
            email
          }
        }
      }
    `;
    }
    if (itemName === 'folder') {
        return gql `
      mutation ADD_COLLABORATORS($itemPk: Int!, $emails: [String]!) {
        addUsersToFolder(input: { folderPk: $itemPk, emails: $emails }) {
          succeeded
          failed {
            code
            email
          }
        }
      }
    `;
    }
    if (itemName === 'group') {
        return gql `
      mutation ADD_MEMBERS_TO_TEAM($itemPk: Int!, $emails: [String]!) {
        addMembersToTeam(input: { teamPk: $itemPk, emails: $emails }) {
          succeeded {
            pk
            avatarUrl
            email
            username
          }
          failed {
            message
            email
          }
        }
      }
    `;
    }
}
export function onRemoveCollaborators(itemName) {
    if (itemName === 'project') {
        return gql `
      mutation REMOVE_COLLABORATORS($itemPk: Int!, $items: [String]!) {
        removeCollaboratorsFromProject(
          input: { projectPk: $itemPk, emails: $items }
        ) {
          succeeded
          failed {
            message
            email
          }
        }
      }
    `;
    }
    if (itemName === 'folder') {
        return gql `
      mutation REMOVE_COLLABORATORS($itemPk: Int!, $items: [Int]!) {
        removeUsersFromFolder(input: { folderPk: $itemPk, userPks: $items }) {
          succeeded
          failed {
            userPk
          }
        }
      }
    `;
    }
}
export function updatePassword(itemName) {
    const { updatePasswordMutation, itemIdField, idType } = queryMeta[itemName];
    return gql `
    mutation ${updatePasswordMutation}($itemId: ${idType}!, $password: String!) {
      ${updatePasswordMutation}(
        input: { ${itemIdField}: $itemId, password: $password }
      ) {
        ok
        ${itemName} {
          passwordProtected
        }
        error {
          code
          message
        }
      }
    }
  `;
}
export const getCompanyGroups = (itemName) => {
    const { pkField, teamEdgeConnection } = queryMeta[itemName];
    return gql `
  query GET_GROUPS(
    $cursor: String
    $pageSize: Int
    $itemPk: Int!
    $name: String!
  ) {
    user {
      pk
      company {
        pk
        groups: teams(first: $pageSize, name: $name, after: $cursor)
          @connection(key: "groups") {
          edges {
            ${teamEdgeConnection}(${pkField}: $itemPk)
            node {
              pk
              name
              guestCount
              memberCount
              members {
                edges {
                  node {
                    pk
                    username
                    avatarUrl
                  }
                }
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
`;
};
export const getGroups = (itemName) => {
    return gql `
    query GET_GROUPS($itemPk: Int!, $cursor: String) {
      ${itemName}(pk: $itemPk) {
        pk
        owner {
          pk
        }
        groups: teams(first: 6, after: $cursor) @connection(key: "groups") {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              pk
              name
              guestCount
              memberCount
              members {
                edges {
                  node {
                    pk
                    username
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
};
export const addGroupsToItem = (itemName) => {
    const { addGroupMutation, pkField } = queryMeta[itemName];
    return gql `
  mutation ADD_GROUPS($itemPk: Int!, $groupsPks: [Int]!) {
    ${addGroupMutation}(input: { ${pkField}: $itemPk, teamPks: $groupsPks }) {
      succeeded {
        pk
        name
        guestCount
        memberCount
        members {
          edges {
            node {
              pk
              username
              avatarUrl
            }
          }
        }
      }
      failed {
        teamPk
        message
        code
      }
    }
  }
`;
};
export const removeGroupsFromItem = (itemName) => {
    const { removeGroupsMutation, pkField } = queryMeta[itemName];
    return gql `
    mutation REMOVE_GROUPS($itemPk: Int!, $teamPks: [Int]!) {
      ${removeGroupsMutation}(
        input: { ${pkField}: $itemPk, teamPks: $teamPks }
      ) {
        succeeded {
          pk
        }
        failed {
          message
          teamPk
        }
      }
    }
  `;
};
